import service from 'utils/request'
const urlObj = {
  toolbar: {
    "start": "/sys/emapflow/definition/queryUserTaskToolbar.do",
    "submit": "/sys/emapflow/definition/queryFirstUserTaskToolbar.do"
  },
  commands: {
    "do_start": "/sys/emapflow/tasks/startFlow.do",
    "do_submit": "/sys/emapflow/tasks/execute.do",
    "do_termination": "/sys/emapflow/tasks/terminateInstance.do",
    "do_change_assignee": "/sys/emapflow/tasks/changeAssignee.do",
    "do_turnback": "/sys/emapflow/tasks/turnback.do",
    "do_callback": "/sys/emapflow/tasks/callback.do",
    "do_process_status": "/sys/emapflow/tasks/queryFlowState.do",
    "do_custom": "/sys/emapflow/tasks/custom.do",
    "do_urgent": "/sys/emapflow/tasks/urgent.do",
    "do_process_track": "/sys/emapflow/tasks/queryFlowTrack.do",
    "do_addAssigneeTask": "/sys/emapflow/tasks/addAssigneeTask.do",
    "do_deleteAssigneeTask": "/sys/emapflow/tasks/deleteAssigneeTask.do",
    "do_already_read": "/sys/emapflow/tasks/alreadyRead.do",
    "do_distribute_submit": "/sys/emapflow/tasks/submitDistribute.do",
    "do_distribute_opinions": "/sys/emapflow/tasks/submitDistributeOpinions.do"
  },
  addOrDelAssignee: "/sys/emapflow/definition/getNextMultiNodesByHistoricTask.do",
  flowConfig: "/sys/emapflow/*default/queryFlowConfig.do",
  taskUrl: "/sys/emaptaskcenter/query/taskUrl.do",
  messageTypes: "/sys/emapflow/*default/queryMessageTypeConfig.do",
  userInfo: "/sys/emapturing/getConfig.do",
  assigneesByProcessInstance: "/sys/emapflow/tasks/getAssigneesByProcessInstance.do",
  urgentInfo: "/sys/emapflow/tasks/getDefaultUrgentMessage.do",
  urgentToFlowCenter: "/sys/emaptaskcenter/receive/press.do",
  usertasks: '/sys/emapflow/definition/getAllUserTaskNodes.do',
  turnGroupUsers: "/sys/emapflow/tasks/getChangeAssigneeGroupsUsers.do",
  sendMsgWays: "/sys/emapflow/*default/queryMessageTypeConfig.do",
  curNodeInfo  : "/sys/emapflow/tasks/getCurrentNodesByTask.do",
  multiInstanceGroups: "/sys/emapflow/usergroup/getGroups.do"
}

const getToolbarBtns = (type, params) => {
  return service({
    url: urlObj.toolbar[type],
    params: params
  })
}

const execCommand = (type, data) => {
  return service({
    url: data.url || urlObj.commands[type],
    method: 'post',
    data: data,
    flag: 'whole'
  })
}

const getAddOrDelAssignee = (data) => {
  return service({
    url: urlObj.addOrDelAssignee,
    method: 'post',
    data: data
  })
}

const getFlowConfig = () => {
  return service({
    url: urlObj.flowConfig,
    params: {"key": "task_center_bizdomain_type"}
  })
}

const getTaskFormUrl = (params) => {
  return service({
    url: urlObj.taskUrl,
    params: params
  })
}

const getMessageTypes = () => {
  return service({
    url: urlObj.messageTypes
  })
}

const getMessageInfo = (params) => {
  return service({
    url: urlObj.urgentInfo,
    params: params
  })
}

const getLoginInfo = () => {
  return service({
    url: urlObj.userInfo
  })
}

const getAssigneesByProcessInstance = (params) => {
  return service({
    url: urlObj.assigneesByProcessInstance,
    params: params
  })
}

const urgentPress = (data) => {
  return service({
    url: urlObj.urgentToFlowCenter,
    method: 'post',
    data: data
  })
}

const queryTurnGroupUsers = (params) => {
  return service({
    url: urlObj.turnGroupUsers,
    params: params
  })
}

const querySendMsgWays = () => {
  return service({
    url: urlObj.sendMsgWays
  })
}

const queryCurNodeInfo = (params) => {
  return service({
    url: urlObj.curNodeInfo,
    params: params
  })
}

const queryMultiInstanceGroups = (params) => {
  return service({
    url: urlObj.multiInstanceGroups,
    params: params
  })
}


const toolbarApi = {
  urlObj, getToolbarBtns, execCommand, getAddOrDelAssignee, getFlowConfig, getTaskFormUrl, getMessageTypes,
  getLoginInfo, getAssigneesByProcessInstance, urgentPress, queryTurnGroupUsers, querySendMsgWays, getMessageInfo,
  queryCurNodeInfo, queryMultiInstanceGroups
}

export {
  urlObj, getToolbarBtns, execCommand, getAddOrDelAssignee, getFlowConfig, getTaskFormUrl, getMessageTypes,
  getLoginInfo, getAssigneesByProcessInstance, urgentPress, queryTurnGroupUsers, querySendMsgWays, getMessageInfo,
  queryCurNodeInfo, queryMultiInstanceGroups
}

export default toolbarApi